import React from 'react';
import { Link } from 'react-router-dom';

import Picture from '../common/Picture';
import noImg from '../img/landing/no-img.jpg';
import noImgWebp from '../img/landing/webp/no-img.webp';

const WodCard = ({ wod, goToUrl, children, className, wodLayout = '' }) => {
  const workoutsFlattened = wod.workouts
    .reduce((flattened, workout) => {
      return [
        ...flattened,
        workout.title,
        workout.subtitles.join(', '),
        ...workout.exercises,
      ];
    }, [])
    .filter((item) => item)
    .slice(0, 3);
  return (
    <div className="o-layout__item u-1/2@lg u-1/1 u-margin-bottom">
      <Link
        className={`c-box ${wod.active ? '' : 'c-box--inactive'} ${wodLayout}`}
        to={goToUrl}
      >
        <div
          className={`u-flex u-flex-column u-align-items-center ${className}`}
        >
          <div className="u-flex u-flex-column u-justify-content-center u-align-items-center">
            <h3 className="u-margin-bottom-small u-color-bright-gray">
              WOD {wod.date && wod.date.format('DD.MM.YYYY')}
            </h3>
            <Picture
              src={wod.image.url ? wod.image.url : noImg}
              srcWebp={wod.image.url ? null : noImgWebp}
              className="u-img-responsive u-object-fit"
              alt="Workout of the Day Img"
              width="100%"
              height="200px"
            />
            <div
              className={`u-color-bright-gray u-margin-vertical-small u-text-center ${
                children ? 'c-box__content--truncate' : ''
              }`}
            >
              <h4 className="u-margin-bottom-small u-text-word-break u-color-royal-blue">
                {wod.name}
              </h4>
              {workoutsFlattened.map((workoutItem, idx) => (
                <p key={`${workoutItem}-${idx}`}>{workoutItem}</p>
              ))}
            </div>
            <div className="u-flex">{children}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default WodCard;
